import { render, staticRenderFns } from "./UpdateRequestList.vue?vue&type=template&id=8301d9a2&"
import script from "./UpdateRequestList.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports